import React from 'react';
import LegalPageLayout from 'features/legal/components/LegalPageLayout/LegalPageLayout';

// Template content pending legal review — required now to support Twilio A2P campaign
// registration for Bagel AI's SMS/MMS number.
function TermsAndConditions() {
  return (
    <LegalPageLayout title="Terms & Conditions" updatedOn="August 19, 2026">
      <p>
        These Terms &amp; Conditions (&quot;Terms&quot;) govern your use of services provided by
        URBAN TXT: Teens Exploring Technology (&quot;URBAN TXT&quot;, &quot;we&quot;, &quot;us&quot;),
        including our SMS/MMS text messaging program. By opting in or otherwise using our
        services, you agree to these Terms.
      </p>

      <h2>SMS/MMS Program Terms</h2>
      <ul>
        <li>
          By providing your mobile phone number and opting in, you consent to receive text
          messages from URBAN TXT, including from our Bagel AI assistant, at the number provided.
        </li>
        <li>
          <strong>Message frequency varies</strong> based on your interactions with us.
        </li>
        <li>
          <strong>Message and data rates may apply.</strong> Check with your mobile carrier for
          details on your plan.
        </li>
        <li>
          Reply <strong>STOP</strong> at any time to cancel. After you send the SMS message STOP,
          we will send you a reply confirming that you have been unsubscribed, and you will
          receive no further messages. Reply <strong>HELP</strong> for help, or contact us using
          the information below.
        </li>
        <li>
          Carriers are not liable for delayed or undelivered messages. We are not responsible for
          delays or failures in message delivery caused by your carrier or device.
        </li>
      </ul>

      <h2>Use of Bagel AI</h2>
      <p>
        Where you use Bagel AI via text message to request work (for example, building or
        updating a website), we will confirm any action that changes or creates something on your
        behalf before it happens. Bagel AI may look up information to answer your questions
        without asking first; it will not make changes without your confirmation.
      </p>

      <h2>Acceptable Use</h2>
      <p>
        You agree not to use our services for any unlawful purpose or to send content that is
        abusive, fraudulent, or infringes on the rights of others.
      </p>

      <h2>No Warranty</h2>
      <p>
        Our services are provided &quot;as is&quot; without warranties of any kind, express or
        implied, to the fullest extent permitted by law.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. The &quot;Last updated&quot; date above
        reflects the most recent revision.
      </p>

      <h2>Contact Us</h2>
      <p>
        Questions about these Terms? Contact URBAN TXT at{' '}
        <a href="mailto:privacy@urbantxt.org">privacy@urbantxt.org</a>.
      </p>
    </LegalPageLayout>
  );
}

export default TermsAndConditions;
